import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/es/servicios/pharmacovigilance/qppv-representante-local")({
  head: () => buildRouteHead("/es/servicios/pharmacovigilance/qppv-representante-local"),
  component: PVOffering,
});

